import { ButtonPrimary } from "components/Atoms/Button";
import React from "react";
import { Message } from "semantic-ui-react";

interface Props {
  documentUrl: string
  onSignClicked: () => void
}

const ViewDocumentInline = (props: Props) => {
  return <div className="document-inline-panel" style={{
    height: "calc(100vh - 144px)",
    minHeight: 700
  }}>
    <object data={`${props.documentUrl}?inline=true`} type="application/pdf" width="100%" height="100%">
      <div className="padding-big">
        <Message color="red">
          Could not load the document or your browser does not support PDFs. Try accesing the document directly:
        </Message>
        <div className="flex margin-top">
          <ButtonPrimary
            href={props.documentUrl}
            label={RESX.ESign.ViewDocument}
          />
          <div className="grow1"></div>
        </div>
      </div>
    </object>
  </div>;
};

export default ViewDocumentInline;